import React from 'react'

export const washingtonSetupVars = {
  siteId: 'washington',
  pathPrefix: '/wa',
  menuHeader: "Discover Washington's Solution for:",
  appUrl: 'https://wa.headed2.com',
  logoImg: '/images/assets/washington/horizontal/dark.svg',
  headerTitle: `The Washington CareerExplorer is a system designed for Washington`
}
